module.exports = __webpack_public_path__ + "img/AsylumVol1.729bdacf.jpeg";